/* tslint:disable */
/* eslint-disable */
/**
 * Mercatus Portal
 * Mercatus Portal
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@gomercatus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
/**
 * EntityTypeApi - axios parameter creator
 * @export
 */
export const EntityTypeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets the number of entities for an entityType
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountOfEntitiesForEntityType: async (entityTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityTypeId' is not null or undefined
            assertParamExists('getCountOfEntitiesForEntityType', 'entityTypeId', entityTypeId)
            const localVarPath = `/navigator/entityTypes/{entityTypeId}/entities/count`
                .replace(`{${"entityTypeId"}}`, encodeURIComponent(String(entityTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets the features that can be enabled for an entityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isStagesEnabledForOrg: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/navigator/entityTypes/features/stages/enabled`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EntityTypeApi - functional programming interface
 * @export
 */
export const EntityTypeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EntityTypeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets the number of entities for an entityType
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCountOfEntitiesForEntityType(entityTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCountOfEntitiesForEntityType(entityTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets the features that can be enabled for an entityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isStagesEnabledForOrg(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isStagesEnabledForOrg(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EntityTypeApi - factory interface
 * @export
 */
export const EntityTypeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EntityTypeApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets the number of entities for an entityType
         * @param {number} entityTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountOfEntitiesForEntityType(entityTypeId: number, options?: any): AxiosPromise<number> {
            return localVarFp.getCountOfEntitiesForEntityType(entityTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets the features that can be enabled for an entityType
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isStagesEnabledForOrg(options?: any): AxiosPromise<boolean> {
            return localVarFp.isStagesEnabledForOrg(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EntityTypeApi - object-oriented interface
 * @export
 * @class EntityTypeApi
 * @extends {BaseAPI}
 */
export class EntityTypeApi extends BaseAPI {
    /**
     * 
     * @summary Gets the number of entities for an entityType
     * @param {number} entityTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public getCountOfEntitiesForEntityType(entityTypeId: number, options?: any) {
        return EntityTypeApiFp(this.configuration).getCountOfEntitiesForEntityType(entityTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets the features that can be enabled for an entityType
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntityTypeApi
     */
    public isStagesEnabledForOrg(options?: any) {
        return EntityTypeApiFp(this.configuration).isStagesEnabledForOrg(options).then((request) => request(this.axios, this.basePath));
    }
}
